import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { REPORT_MODULE } from '../../configs/moduleNames';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';

export const LOAD_REPORT_LIST = '_LOAD_REPORT_LIST';
export const LOAD_REPORT_BY_ID = '_LOAD_REPORT_BY_ID';
export const EDIT_REPORT_BY_ID = '_EDIT_REPORT_BY_ID';
export const CREATE_REPORT = '_CREATE_REPORT';
export const DELETE_REPORT = '_DELETE_REPORT';
export const LOAD_REPORT_TEMPLATE_LIST = '_LOAD_REPORT_TEMPLATE_LIST';
export const LOAD_REPORT_TEMPLATE_BY_ID = '_LOAD_REPORT_TEMPLATE_BY_ID';
export const EDIT_REPORT_TEMPLATE_BY_ID = '_EDIT_REPORT_TEMPLATE_BY_ID';
export const CREATE_REPORT_TEMPLATE = '_CREATE_REPORT_TEMPLATE';
export const DELETE_REPORT_TEMPLATE = '_DELETE_REPORT_TEMPLATE';
export const LOAD_REPORT_EXPORT_LIST = '_LOAD_REPORT_EXPORT_LIST';
export const LOAD_REPORT_EXPORT_BY_ID = '_LOAD_REPORT_EXPORT_BY_ID';
export const EDIT_REPORT_EXPORT_BY_ID = '_EDIT_REPORT_EXPORT_BY_ID';
export const CREATE_REPORT_EXPORT = '_CREATE_REPORT_EXPORT';
export const DELETE_REPORT_EXPORT = '_DELETE_REPORT_EXPORT';
export const LOAD_TEMPLATE_ATTRIBUTES = '_LOAD_TEMPLATE_ATTRIBUTES';

export const loadReportList = createDeferredAction(REPORT_MODULE + LOAD_REPORT_LIST);
export const loadReportListSuccessful = createAction(REPORT_MODULE + LOAD_REPORT_LIST + SUCCESSFUL);
export const loadReportListFailed = createAction(REPORT_MODULE + LOAD_REPORT_LIST + FAILED);

export const loadReportById = createDeferredAction(REPORT_MODULE + LOAD_REPORT_BY_ID);
export const loadReportByIdSuccessful = createAction(REPORT_MODULE + LOAD_REPORT_BY_ID + SUCCESSFUL);
export const loadReportByIdFailed = createAction(REPORT_MODULE + LOAD_REPORT_BY_ID + FAILED);

export const editReportById = createDeferredAction(REPORT_MODULE + EDIT_REPORT_BY_ID);
export const editReportByIdSuccessful = createAction(REPORT_MODULE + EDIT_REPORT_BY_ID + SUCCESSFUL);
export const editReportByIdFailed = createAction(REPORT_MODULE + EDIT_REPORT_BY_ID + FAILED);

export const createReport = createDeferredAction(REPORT_MODULE + CREATE_REPORT);
export const createReportSuccessful = createAction(REPORT_MODULE + CREATE_REPORT + SUCCESSFUL);
export const createReportFailed = createAction(REPORT_MODULE + CREATE_REPORT + FAILED);

export const deleteReport = createDeferredAction(REPORT_MODULE + DELETE_REPORT);
export const deleteReportSuccessful = createAction(REPORT_MODULE + DELETE_REPORT + SUCCESSFUL);
export const deleteReportFailed = createAction(REPORT_MODULE + DELETE_REPORT + FAILED);

export const loadReportTemplateList = createDeferredAction(REPORT_MODULE + LOAD_REPORT_TEMPLATE_LIST);
export const loadReportTemplateListSuccessful = createAction(REPORT_MODULE + LOAD_REPORT_TEMPLATE_LIST + SUCCESSFUL);
export const loadReportTemplateListFailed = createAction(REPORT_MODULE + LOAD_REPORT_TEMPLATE_LIST + FAILED);

export const loadReportTemplateById = createDeferredAction(REPORT_MODULE + LOAD_REPORT_TEMPLATE_BY_ID);
export const loadReportTemplateByIdSuccessful = createAction(REPORT_MODULE + LOAD_REPORT_TEMPLATE_BY_ID + SUCCESSFUL);
export const loadReportTemplateByIdFailed = createAction(REPORT_MODULE + LOAD_REPORT_TEMPLATE_BY_ID + FAILED);

export const editReportTemplateById = createDeferredAction(REPORT_MODULE + EDIT_REPORT_TEMPLATE_BY_ID);
export const editReportTemplateByIdSuccessful = createAction(REPORT_MODULE + EDIT_REPORT_TEMPLATE_BY_ID + SUCCESSFUL);
export const editReportTemplateByIdFailed = createAction(REPORT_MODULE + EDIT_REPORT_TEMPLATE_BY_ID + FAILED);

export const createReportTemplate = createDeferredAction(REPORT_MODULE + CREATE_REPORT_TEMPLATE);
export const createReportTemplateSuccessful = createAction(REPORT_MODULE + CREATE_REPORT_TEMPLATE + SUCCESSFUL);
export const createReportTemplateFailed = createAction(REPORT_MODULE + CREATE_REPORT_TEMPLATE + FAILED);

export const deleteReportTemplate = createDeferredAction(REPORT_MODULE + DELETE_REPORT_TEMPLATE);
export const deleteReportTemplateSuccessful = createAction(REPORT_MODULE + DELETE_REPORT_TEMPLATE + SUCCESSFUL);
export const deleteReportTemplateFailed = createAction(REPORT_MODULE + DELETE_REPORT_TEMPLATE + FAILED);

export const loadReportExportList = createDeferredAction(REPORT_MODULE + LOAD_REPORT_EXPORT_LIST);
export const loadReportExportListSuccessful = createAction(REPORT_MODULE + LOAD_REPORT_EXPORT_LIST + SUCCESSFUL);
export const loadReportExportListFailed = createAction(REPORT_MODULE + LOAD_REPORT_EXPORT_LIST + FAILED);

export const loadReportExportById = createDeferredAction(REPORT_MODULE + LOAD_REPORT_EXPORT_BY_ID);
export const loadReportExportByIdSuccessful = createAction(REPORT_MODULE + LOAD_REPORT_EXPORT_BY_ID + SUCCESSFUL);
export const loadReportExportByIdFailed = createAction(REPORT_MODULE + LOAD_REPORT_EXPORT_BY_ID + FAILED);

export const editReportExportById = createDeferredAction(REPORT_MODULE + EDIT_REPORT_EXPORT_BY_ID);
export const editReportExportByIdSuccessful = createAction(REPORT_MODULE + EDIT_REPORT_EXPORT_BY_ID + SUCCESSFUL);
export const editReportExportByIdFailed = createAction(REPORT_MODULE + EDIT_REPORT_EXPORT_BY_ID + FAILED);

export const createReportExport = createDeferredAction(REPORT_MODULE + CREATE_REPORT_EXPORT);
export const createReportExportSuccessful = createAction(REPORT_MODULE + CREATE_REPORT_EXPORT + SUCCESSFUL);
export const createReportExportFailed = createAction(REPORT_MODULE + CREATE_REPORT_EXPORT + FAILED);

export const deleteReportExport = createDeferredAction(REPORT_MODULE + DELETE_REPORT_EXPORT);
export const deleteReportExportSuccessful = createAction(REPORT_MODULE + DELETE_REPORT_EXPORT + SUCCESSFUL);
export const deleteReportExportFailed = createAction(REPORT_MODULE + DELETE_REPORT_EXPORT + FAILED);

export const loadTemplateAttributes = createDeferredAction(REPORT_MODULE + LOAD_TEMPLATE_ATTRIBUTES);
export const loadTemplateAttributesSuccessful = createAction(REPORT_MODULE + LOAD_TEMPLATE_ATTRIBUTES + SUCCESSFUL);
export const loadTemplateAttributesFailed = createAction(REPORT_MODULE + LOAD_TEMPLATE_ATTRIBUTES + FAILED);
